import { render, staticRenderFns } from "./CAlert.vue?vue&type=template&id=8cdbeba8&scoped=true&"
import script from "./CAlert.vue?vue&type=script&lang=js&"
export * from "./CAlert.vue?vue&type=script&lang=js&"
import style0 from "./CAlert.vue?vue&type=style&index=0&id=8cdbeba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdbeba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
